import React from "react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import type { InjectReadiness } from "../../types/reportStrategyPine";
import {
  getInjectReadinessDisplay,
  injectReadinessSummary,
  shouldShowInjectReadinessBadge,
  type PineUxCopy,
} from "../../utils/pineIrUi";
import { STRATEGY_PINE_SECTION_DESC_CLASS, STRATEGY_PINE_SECTION_LABEL_CLASS } from "./StrategyPineSectionCard";
import {
  STRATEGY_PINE_ALERT_CLASS,
  StrategyPineAlertIcon,
  strategyPineAlertVariant,
} from "./strategyPineAlertUi";

export type StrategyPineInjectSummaryProps = {
  injectReadiness?: InjectReadiness | string | null;
  injectReadinessUx?: Record<string, PineUxCopy> | null;
};

export function StrategyPineInjectSummary({
  injectReadiness,
  injectReadinessUx,
}: StrategyPineInjectSummaryProps): React.ReactElement | null {
  if (!shouldShowInjectReadinessBadge(injectReadiness)) return null;
  const ux = getInjectReadinessDisplay(injectReadiness, injectReadinessUx);
  if (!ux) return null;

  const summary = injectReadinessSummary(injectReadiness);
  const tone = summary?.status ?? "info";

  return (
    <Alert variant={strategyPineAlertVariant(tone)} className={STRATEGY_PINE_ALERT_CLASS}>
      <StrategyPineAlertIcon tone={tone} />
      <AlertTitle className={STRATEGY_PINE_SECTION_LABEL_CLASS}>{ux.title}</AlertTitle>
      <AlertDescription className={STRATEGY_PINE_SECTION_DESC_CLASS}>
        {ux.description}
      </AlertDescription>
    </Alert>
  );
}
